module.exports = __webpack_public_path__ + "static/img/slide-4-bike.e1edd6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-4-bike.png
// module id = IqHr
// module chunks = 1